import type { MagazineArticle } from '../helpers/magazineCategory';
import type { ReactNode } from 'react';
import { buildMagazinePageHref, type MagazinePageHrefContext } from '../helpers/buildMagazinePageHref';
import { MagazineArticleGrid } from '../MagazineArticleGrid/MagazineArticleGrid';
import { MagazinePagination } from '../MagazinePagination/MagazinePagination';

type MagazineArticlesFeedProps = {
  articles: readonly MagazineArticle[];
  totalPages: number;
  currentPage: number;
  baseImgUrl: string;
  hrefContext: MagazinePageHrefContext;
  emptyMessage?: string;
  isEmpty?: boolean;
  priorityFirstCard?: boolean;
  leadingContent?: ReactNode;
  'data-testid'?: string;
};

function MagazineArticlesFeed({
  articles,
  totalPages,
  currentPage,
  baseImgUrl,
  hrefContext,
  emptyMessage,
  isEmpty = articles.length === 0,
  priorityFirstCard = false,
  leadingContent,
  'data-testid': dataTestId = 'magazine-articles-feed',
}: MagazineArticlesFeedProps) {
  return (
    <div data-testid={dataTestId}>
      {leadingContent}
      {isEmpty && emptyMessage ? (
        <p className="text-foreground-subtle paragraph" data-testid={`${dataTestId}-empty`}>
          {emptyMessage}
        </p>
      ) : (
        <MagazineArticleGrid articles={articles} baseImgUrl={baseImgUrl} currentPage={currentPage} priorityFirstCard={priorityFirstCard} />
      )}
      <MagazinePagination className="mt-8" currentPage={currentPage} totalPages={totalPages} getPageHref={page => buildMagazinePageHref(hrefContext, page)} />
    </div>
  );
}

export { MagazineArticlesFeed, type MagazineArticlesFeedProps };
